<div class="overlay" (click)="cerrar()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="header">
      <h3>Invitar usuario</h3>
      <button class="close-btn" (click)="cerrar()">&times;</button>
    </div>

    <div class="body">
      <p>Ingresa el correo del usuario. Se generará un link de invitación que podrás copiar y compartir.</p>

      <div class="input-row">
        <input #emailInput
               type="email"
               placeholder="correo@ejemplo.com"
               [(ngModel)]="email"
               (keydown.enter)="enviar()"
               [disabled]="loading">
        <select id="invite-role" [(ngModel)]="roleId" [attr.disabled]="loading ? '' : null">
          <option [ngValue]="2">User</option>
          <option [ngValue]="1">Admin</option>
        </select>
        <button (click)="enviar()" [disabled]="loading || !email.trim()">
          {{ loading ? 'Enviando...' : 'Enviar invitación' }}
        </button>
      </div>

      <div class="loading" *ngIf="loading">Generando invitación...</div>

      <div class="msg" *ngIf="mensaje" [class.success]="exito" [class.error]="!exito">
        {{ mensaje }}
      </div>

      <div class="link-box" *ngIf="inviteLink">
        <input #linkInput type="text" [value]="inviteLink" readonly (click)="linkInput.select()">
        <button class="copy-btn" [class.copied]="copiado" (click)="copiarLink(linkInput)">
          {{ copiado ? 'Copiado' : 'Copiar' }}
        </button>
      </div>
    </div>

    <div class="footer">
      <button (click)="cerrar()">Cerrar</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/invite-modal/invite-modal.component.html